export const imageSchema = {
  image: {
    presence: { allowEmpty: false, message: "is required" },
    format: {
      pattern: /^[a-zA-Z0-9\s_\\.\-():\/%]+(.jpg|.png|.bmp|.JPG|.svg)$/,
      message: "has to be a .jpg/.png/.bmp/.svg file"
    }
  }
};

export const settingsSchema = {
  botName: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 30
    }
  },
  welcomeMessage: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 1000
    }
  },
  examplePhraseA: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 100
    }
  },
  examplePhraseB: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 100
    }
  },
  examplePhraseC: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 100
    }
  },
  chatImageLink: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 200
    }
  },
  domain: {
    presence: { allowEmpty: false, message: "is required" },
    format: {
      pattern: /^\s*(?:(?:((\w)|(\*))+(?:-+((\w)|(\*))+)*\.)+[a-z]+)\s*(?:,\s*(?:(?:((\w)|(\*))+(?:-+((\w)|(\*))+)*\.)+[a-z]+)\s*)*$/,
      message: "invalid"
    }
  },
  desktopRight: {
    numericality: true
  },
  desktopBottom: {
    numericality: true
  },
  mobileRight: {
    numericality: true
  },
  mobileBottom: {
    numericality: true
  }
};
